import { CardSuit } from "../card/Card";
import { LoaderFileKeys } from "../constant/AppConstants";
import { IconButton } from "../../ui/IconButton";
import { LabelButton } from "../../ui/LabelButton";
import { TablePopupWindow } from "./TablePopupWindow";
import { ButtonBase, ButtonEvents } from "../../ui/ButtonBase";
import { AppSettings } from "../managers/AppSettings";
import { LabelIconButton } from "../../ui/LabelIconButton";
import { RectSize } from "../../utils/RectSize";
import { IInteractive } from "../../interfaces/IInteractive";
import { AppLocalization, LanguageId } from "../localization/AppLocalization";
import { LayoutDataManager } from "../managers/LayoutDataManager";
import { ContraBidChoice, TextureData } from "../../types/types";
import { ChoiceSelector, ChoiceSelectorEvents } from "../views/ChoiceSelector";
import { ScreenOrientationType } from "../../utils/GetOrientation";
import { VariationId } from "../screen/TableScreen";
import { AppAudioPlayer, SoundEffectKeys } from "../../audio/AppAudioPlayer";
import { PopupBiddingChoiceType } from "./PopupBiddingTakeSuit";
import { ScreenManager } from "../../managers/ScreenManager";


/**
 * Matches index in @see VariationData.dealComplete.results.itemsById.contra.choices
 */
export enum ContraType {
    NONE = -1,
    /**
     * Coinche: coinche
     * Contree: double
     */
    CONTRA = 0,
    /**
     * Coinche: surcoinche
     * Contree: redouble
     */
    RECONTRA = 1,
}

export enum LayoutTypeNTAT {
    NO_NTAT,
    YES_NTAT,
}

export class PopupBiddingContra
    extends TablePopupWindow {
    public nsContentBg: Phaser.GameObjects.NineSlice;
    public nsContentBgExtrusion: number = 25; // extrude to cover for outer drop shadow size
    public nsHeaderBg: Phaser.GameObjects.NineSlice;
    public txtHeader: Phaser.GameObjects.Text;
    public btnSuitSpades: IconButton;
    public btnSuitClubs: IconButton;
    public btnSuitDiamonds: IconButton;
    public btnSuitHearts: IconButton;
    public btnNoTrumps: LabelIconButton;
    public btnAllTrumps: LabelIconButton;
    public slider: ChoiceSelector; // TODO: with nav
    public btnPass: LabelButton;
    public btnContra: LabelButton;
    protected orientationLayoutsData;
    protected cardTextureData: TextureData;
    /**
     * Auto-enable on Show and auto-disable on Hide all interactives eg buttons
     */
    protected interactives: IInteractive[];
    /**
     * various variables pertaining to state
     */
    protected curOrientationType: ScreenOrientationType;
    /**
     * Does current layout have or not have NT & AT buttons.
     */
    protected curLayoutTypeNTAT: LayoutTypeNTAT = LayoutTypeNTAT.NO_NTAT;
    /**
     * 
     */
    protected choices: string[];
    /**
     * 
     */
    protected curContraType: ContraType;


    public override Init(): void {
        // >> create screenOverlayHitArea
        super.Init();

        this.interactives = [];
        this.curOrientationType = ScreenManager.GetOrientation();
        const layoutItemLandscapeOffsetX: number = 200;
        this.orientationLayoutsData = [
            // Portrait
            [
                // NO_NTAT
                {
                    bg: {
                        width: 500, height: 600,
                    },
                    slider: {
                        x: 0, y: -200, width: 490,
                    },
                    btnSuitSpades: {
                        x: -100, y: -100,
                    },
                    btnSuitHearts: {
                        x: 100, y: -100,
                    },
                    btnSuitClubs: {
                        x: -100, y: 0,
                    },
                    btnSuitDiamonds: {
                        x: 100, y: 0,
                    },
                    btnContra: {
                        x: 0, y: 100
                    },
                    btnPass: {
                        x: 0, y: 200
                    }
                },
                // YES_NTAT
                {
                    bg: {
                        width: 500, height: 700,
                    },
                    slider: {
                        x: 0, y: -250, width: 490,
                    },
                    btnSuitSpades: {
                        x: -100, y: -150,
                    },
                    btnSuitHearts: {
                        x: 100, y: -150,
                    },
                    btnSuitClubs: {
                        x: -100, y: -50,
                    },
                    btnSuitDiamonds: {
                        x: 100, y: -50,
                    },
                    btnNoTrumps: {
                        visible: true, x: -100, y: 50,
                    },
                    btnAllTrumps: {
                        visible: true, x: 100, y: 50,
                    },
                    btnContra: {
                        x: 0, y: 150
                    },
                    btnPass: {
                        x: 0, y: 250
                    }
                },

            ],
            // Landscape
            [
                // NO_NTAT
                {
                    bg: {
                        width: 900, height: 390,
                    },
                    btnSuitSpades: {
                        x: -layoutItemLandscapeOffsetX - 100, y: 0,
                    },
                    btnSuitHearts: {
                        x: -layoutItemLandscapeOffsetX + 100, y: 0,
                    },
                    btnSuitClubs: {
                        x: -layoutItemLandscapeOffsetX - 100, y: 100,
                    },
                    btnSuitDiamonds: {
                        x: -layoutItemLandscapeOffsetX + 100, y: 100,
                    },
                    slider: {
                        x: 0, y: -100, width: 980,
                    },
                    btnContra: {
                        x: layoutItemLandscapeOffsetX + 0, y: 0
                    },
                    btnPass: {
                        x: layoutItemLandscapeOffsetX - 0, y: 100
                    },
                },
                // YES_NTAT
                {
                    bg: {
                        width: 900, height: 390,
                    },
                    btnSuitSpades: {
                        x: -layoutItemLandscapeOffsetX - 100, y: -100,
                    },
                    btnSuitHearts: {
                        x: -layoutItemLandscapeOffsetX + 100, y: -100,
                    },
                    btnSuitClubs: {
                        x: -layoutItemLandscapeOffsetX - 100, y: 0,
                    },
                    btnSuitDiamonds: {
                        x: -layoutItemLandscapeOffsetX + 100, y: 0,
                    },
                    btnNoTrumps: {
                        visible: true, x: -layoutItemLandscapeOffsetX - 100, y: 100,
                    },
                    btnAllTrumps: {
                        visible: true, x: -layoutItemLandscapeOffsetX + 100, y: 100,
                    },
                    slider: {
                        x: layoutItemLandscapeOffsetX + 0, y: -100, width: 490,
                    },
                    btnContra: {
                        x: layoutItemLandscapeOffsetX + 0, y: 0
                    },
                    btnPass: {
                        x: layoutItemLandscapeOffsetX - 0, y: 100
                    },
                },
            ]
        ];
    }

    public override Build(): void {
        // console.log("PopupBiddingSub::Build");

        const btnScale: number = 0.8;
        const btnIconScale: number = 1.0;

        const nsContentBgBorderSize = 55;
        this.nsContentBg = this.scene.make.nineslice({
            key: LoaderFileKeys.ui,
            frame: "rect-black-w72-r24-A80-ds.png",
            leftWidth: nsContentBgBorderSize,
            rightWidth: nsContentBgBorderSize,
            topHeight: nsContentBgBorderSize,
            bottomHeight: nsContentBgBorderSize,
        });
        this.add(this.nsContentBg);

        // header bg
        const nsHeaderBgBorderSize = 46;
        this.nsHeaderBg = this.scene.make.nineslice({
            key: LoaderFileKeys.ui,
            frame: "bidPopup-header-bg.png",
            leftWidth: nsHeaderBgBorderSize,
            rightWidth: nsHeaderBgBorderSize,
        });
        this.add(this.nsHeaderBg);

        // header title
        this.txtHeader = this.scene.make.text({
            style: {
                color: AppSettings.colors.whiteString,
                fontSize: "30px",
                align: "center",
                fontFamily: AppSettings.fontFamilies.MontserratBold,
                metrics: AppSettings.metrics.montserratBold30,
            }
        });
        this.txtHeader.setOrigin(0.5);
        this.add(this.txtHeader);

        // slider
        this.slider = new ChoiceSelector(this.scene);
        this.slider.Init(
            {
                texture: LoaderFileKeys.ui, frame: "btn-oval9-bg-out.png"
            },
            {
                out: { texture: LoaderFileKeys.ui, frame: "btn-round2-bg-out.png" },
                over: { texture: LoaderFileKeys.ui, frame: "btn-round2-bg-over.png" },
                disabled: { texture: LoaderFileKeys.ui, frame: "btn-round2-bg-disabled.png" }
            },
            {
                out: { texture: LoaderFileKeys.ui, frame: "btn-round3-bg-out.png" },
                over: { texture: LoaderFileKeys.ui, frame: "btn-round3-bg-over.png" },
                disabled: { texture: LoaderFileKeys.ui, frame: "btn-round2-bg-disabled.png" }
            }
        );
        this.slider.Build();
        this.slider.setScale(btnScale);
        this.add(this.slider);

        // btnSuitSpades
        this.btnSuitSpades = new IconButton(this.scene);
        this.btnSuitSpades.setData({ choiceType: PopupBiddingChoiceType.SPADES });
        this.btnSuitSpades.InitBase({
            out: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-out.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-disabled.png" },
        });
        this.btnSuitSpades.InitIcon({
            out: { texture: LoaderFileKeys.ui, frame: "icon-choice-spades-out.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "icon-choice-spades-disabled.png" },
        }, null, btnIconScale);
        this.btnSuitSpades.PostInit(20); // sets interactive
        this.btnSuitSpades.setScale(btnScale);
        this.interactives.push(this.btnSuitSpades);
        this.add(this.btnSuitSpades);

        // btnSuitHearts
        this.btnSuitHearts = new IconButton(this.scene);
        this.btnSuitHearts.setData({ choiceType: PopupBiddingChoiceType.HEARTS });
        this.btnSuitHearts.InitBase({
            out: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-out.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-disabled.png" },
        });
        this.btnSuitHearts.InitIcon({
            out: { texture: LoaderFileKeys.ui, frame: "icon-choice-hearts-out.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "icon-choice-hearts-disabled.png" },
        }, null, btnIconScale);
        this.btnSuitHearts.PostInit(20);
        this.btnSuitHearts.setScale(btnScale);
        this.interactives.push(this.btnSuitHearts);
        this.add(this.btnSuitHearts);

        // btnSuitClubs
        this.btnSuitClubs = new IconButton(this.scene);
        this.btnSuitClubs.setData({ choiceType: PopupBiddingChoiceType.CLUBS });
        this.btnSuitClubs.InitBase({
            out: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-out.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-disabled.png" },
        });
        this.btnSuitClubs.InitIcon({
            out: { texture: LoaderFileKeys.ui, frame: "icon-choice-clubs-out.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "icon-choice-clubs-disabled.png" },
        }, null, btnIconScale);
        this.btnSuitClubs.PostInit(20);
        this.btnSuitClubs.setScale(btnScale);
        this.interactives.push(this.btnSuitClubs);
        this.add(this.btnSuitClubs);

        // btnSuitDiamonds
        this.btnSuitDiamonds = new IconButton(this.scene);
        this.btnSuitDiamonds.setData({ choiceType: PopupBiddingChoiceType.DIAMONDS });
        this.btnSuitDiamonds.InitBase({
            out: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-out.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-disabled.png" },
        });
        this.btnSuitDiamonds.InitIcon({
            out: { texture: LoaderFileKeys.ui, frame: "icon-choice-diamonds-out.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "icon-choice-diamonds-disabled.png" },
        }, null, btnIconScale);
        this.btnSuitDiamonds.PostInit(20);
        this.btnSuitDiamonds.setScale(btnScale);
        this.interactives.push(this.btnSuitDiamonds);
        this.add(this.btnSuitDiamonds);

        // btnNoTrumps
        this.btnNoTrumps = new LabelIconButton(this.scene);
        // this.btnNoTrumps.name = "btnNoTrumps";
        this.btnNoTrumps.setData({ choiceType: PopupBiddingChoiceType.NOTRUMPS });
        this.btnNoTrumps.InitBase({
            out: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-out.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-disabled.png" },
        });
        this.btnNoTrumps.InitLabel(
            {
                out: {
                    color: "#000",
                    fontSize: "60px",
                    fontFamily: AppSettings.fontFamilies.MontserratBold,
                    metrics: AppSettings.metrics.montserratBold60,
                },
                disabled: {
                    color: "#999",
                    fontSize: "60px",
                    fontFamily: AppSettings.fontFamilies.MontserratBold,
                    metrics: AppSettings.metrics.montserratBold60,
                },
            },
            new Phaser.Geom.Point(20, 0),
        );
        this.btnNoTrumps.label.setOrigin(0.5);
        this.btnNoTrumps.InitIcon({
            out: { texture: LoaderFileKeys.cardsDeck, frame: LayoutDataManager.GetSharedData().general.noTrumpsIconFrame.out },
            disabled: { texture: LoaderFileKeys.cardsDeck, frame: LayoutDataManager.GetSharedData().general.noTrumpsIconFrame.disabled },
        }, new Phaser.Geom.Point(-50, 0), btnIconScale);
        this.btnNoTrumps.PostInit(20);
        this.btnNoTrumps.setScale(btnScale);
        this.interactives.push(this.btnNoTrumps);
        this.add(this.btnNoTrumps);

        // btnAllTrumps
        this.btnAllTrumps = new LabelIconButton(this.scene);
        // this.btnAllTrumps.name = "btnAllTrumps";
        this.btnAllTrumps.setData({ choiceType: PopupBiddingChoiceType.ALLTRUMPS });
        this.btnAllTrumps.InitBase({
            out: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-out.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "btn-choice-bg-disabled.png" },
        });
        this.btnAllTrumps.InitLabel(
            // label states data
            {
                out: {
                    color: "#000",
                    fontSize: "60px",
                    fontFamily: AppSettings.fontFamilies.MontserratBold,
                    metrics: AppSettings.metrics.montserratBold60,
                },
                disabled: {
                    color: "#999",
                    fontSize: "60px",
                    fontFamily: AppSettings.fontFamilies.MontserratBold,
                    metrics: AppSettings.metrics.montserratBold60,
                },
            },
            // label offset
            new Phaser.Geom.Point(20, 0)
        );
        this.btnAllTrumps.label.setOrigin(0.5);
        this.btnAllTrumps.InitIcon({
            out: { texture: LoaderFileKeys.cardsDeck, frame: LayoutDataManager.GetSharedData().general.allTrumpsIconFrame.out },
            disabled: { texture: LoaderFileKeys.cardsDeck, frame: LayoutDataManager.GetSharedData().general.allTrumpsIconFrame.disabled },
        }, new Phaser.Geom.Point(-50, 0), btnIconScale);
        this.btnAllTrumps.PostInit(20);
        this.btnAllTrumps.setScale(btnScale);
        this.interactives.push(this.btnAllTrumps);
        this.add(this.btnAllTrumps);

        // btnContra
        this.btnContra = new LabelButton(this.scene);
        this.btnContra.setData({ choiceType: PopupBiddingChoiceType.CONTRA_RECONTRA });
        this.btnContra.InitBase({
            out: { texture: LoaderFileKeys.ui, frame: "btn-oval3-bg-out.png" },
            disabled: { texture: LoaderFileKeys.ui, frame: "btn-oval3-bg-disabled.png" },
        });
        this.btnContra.InitLabel({
            out: {
                color: "#000",
                fontSize: "60px",
                fontFamily: AppSettings.fontFamilies.MontserratBold,
                metrics: AppSettings.metrics.montserratBold60,
            },
            disabled: {
                color: "#999",
                fontSize: "60px",
                fontFamily: AppSettings.fontFamilies.MontserratBold,
                metrics: AppSettings.metrics.montserratBold60,
            }
        }
        );
        this.btnContra.label.setOrigin(0.5);
        this.btnContra.PostInit(20);
        this.btnContra.setScale(btnScale);
        this.interactives.push(this.btnContra);
        this.add(this.btnContra);

        // btnPass
        this.btnPass = new LabelButton(this.scene);
        this.btnPass.setData({ choiceType: PopupBiddingChoiceType.PASS });
        this.btnPass.InitBase({
            out: { texture: LoaderFileKeys.ui, frame: "btn-oval3-bg-out.png" },
        });
        this.btnPass.InitLabel(
            {
                out: {
                    color: "#000",
                    fontSize: "60px",
                    fontFamily: AppSettings.fontFamilies.MontserratBold,
                    metrics: AppSettings.metrics.montserratBold60,
                },
                disabled: {
                    color: "#999",
                    fontSize: "60px",
                    fontFamily: AppSettings.fontFamilies.MontserratBold,
                    metrics: AppSettings.metrics.montserratBold60,
                }
            }
        );
        this.btnPass.label.setOrigin(0.5);
        this.btnPass.PostInit(20);
        this.btnPass.setScale(btnScale);
        this.interactives.push(this.btnPass);
        this.add(this.btnPass);
    }

    /**
     * 
     * @param orientationType 
     * @param noTrumps enabled or disabled
     * @param allTrumps enabled or disabled
     */
    public SetOrientation(
        orientationType: ScreenOrientationType,
        updateView: boolean = false,
    ): void {
        if (orientationType != this.curOrientationType) {
            this.curOrientationType = orientationType;

            if (updateView) {
                this.UpdateView();
            }
        }
    }

    public SetLayoutNTAT(
        layoutNTAT: LayoutTypeNTAT,
        updateView: boolean = false,
    ): void {
        if (layoutNTAT != this.curLayoutTypeNTAT) {
            this.curLayoutTypeNTAT = layoutNTAT;

            if (updateView) {
                this.UpdateView();
            }
        }
    }

    public UpdateView(): void {
        const curLayoutData = this.orientationLayoutsData[this.curOrientationType][this.curLayoutTypeNTAT];

        this.nsContentBg.setSize(
            curLayoutData.bg.width + 2 * this.nsContentBgExtrusion,
            curLayoutData.bg.height + 2 * this.nsContentBgExtrusion
        );

        this.txtHeader.y =
            this.nsHeaderBg.y = -curLayoutData.bg.height * 0.5;

        this.btnSuitSpades.setPosition(curLayoutData.btnSuitSpades.x, curLayoutData.btnSuitSpades.y);
        this.btnSuitHearts.setPosition(curLayoutData.btnSuitHearts.x, curLayoutData.btnSuitHearts.y);
        this.btnSuitClubs.setPosition(curLayoutData.btnSuitClubs.x, curLayoutData.btnSuitClubs.y);
        this.btnSuitDiamonds.setPosition(curLayoutData.btnSuitDiamonds.x, curLayoutData.btnSuitDiamonds.y);
        this.btnPass.setPosition(curLayoutData.btnPass.x, curLayoutData.btnPass.y);
        this.btnContra.setPosition(curLayoutData.btnContra.x, curLayoutData.btnContra.y);

        this.btnNoTrumps.visible = Boolean(curLayoutData.btnNoTrumps?.visible);
        if (this.btnNoTrumps.visible) {
            this.btnNoTrumps.setPosition(curLayoutData.btnNoTrumps.x, curLayoutData.btnNoTrumps.y);
        }
        this.btnAllTrumps.visible = Boolean(curLayoutData.btnAllTrumps?.visible);
        if (this.btnAllTrumps.visible) {
            this.btnAllTrumps.setPosition(curLayoutData.btnAllTrumps.x, curLayoutData.btnAllTrumps.y);
        }
        this.slider.setPosition(curLayoutData.slider.x, curLayoutData.slider.y);
        this.slider.SetWidth(curLayoutData.slider.width);
    }

    public override SetData(inputData: any): void {
        // inputData
        super.SetData(inputData);

        // parse/apply inputData?
    }

    /**
     * Set contra button label
     * @param sContra 
     */
    public SetContraType(contraType: ContraType): void {
        // console.log("SetContraType",ContraType[contraType]);

        if (contraType != -1) {
            this.curContraType = contraType;
            this.btnContra.label.text = AppLocalization.GetVariationData().table.bidPopup.contraBtn.choices[contraType];
        }
    }

    public override Show(animated: boolean = true): void {
        super.Show(animated);

        // enable all interactives
        this.SetInteractive(true);
    }

    public override Hide(animated: boolean = true): void {
        super.Hide(animated);
        // disable all
        this.SetInteractive(false);
    }

    /**
     * SetInteractive on all children
     */
    public SetInteractive(value: boolean): void {
        // console.log("SetInteractive", value);

        let setEnabled: boolean = false;
        for (let i = 0; i < this.interactives.length; i++) {
            const btn = this.interactives[i];
            const btnChoiceIndex: PopupBiddingChoiceType = (btn as ButtonBase).getData("choiceType");
            if (this.inputData != undefined && this.inputData.disabledChoices != undefined) {
                // if button should be disabled
                if (this.inputData.disabledChoices.indexOf(btnChoiceIndex) != -1) {
                    setEnabled = false;
                }
                else {
                    setEnabled = value;
                }
            }
            else {
                setEnabled = value;
            }

            // apply interactivity and listeners
            btn.SetInteractive(setEnabled);
            if (setEnabled) {
                (btn as ButtonBase).on(ButtonEvents.CLICK, this.OnButtonClicked, { root: this, target: btn });
            }
            else {
                (btn as ButtonBase).off(ButtonEvents.CLICK, this.OnButtonClicked);
            }
        }
        this.slider.SetInteractive(value);
        if (setEnabled) {
            this.slider.GetEventEmitter().on(ChoiceSelectorEvents.CHANGE, this.OnSliderValueChange, this);
        }
        else {
            this.slider.GetEventEmitter().off(ChoiceSelectorEvents.CHANGE, this.OnSliderValueChange);
        }
    }

    public OnButtonClicked(): void {
        const root: PopupBiddingContra = this["root"] as PopupBiddingContra;
        const btn: ButtonBase = this["target"] as ButtonBase;
        const choiceType: PopupBiddingChoiceType = btn.getData("choiceType");
        const choiceValueIndex: number = (
            (choiceType == PopupBiddingChoiceType.PASS) ||
            (choiceType == PopupBiddingChoiceType.CONTRA_RECONTRA)
        ) ? -1 : root.slider.GetValueIndex(); // 0=80, 1=90, ..., N=GENERALE
        // console.log("OnButtonClicked; choiceValueIndex:", choiceValueIndex)

        // button click
        AppAudioPlayer.PlaySfx(SoundEffectKeys.click5);

        const bidChoice: ContraBidChoice = {
            choiceType: choiceType,
            choiceValueIndex: choiceValueIndex,
        }
        root.inputData.onComplete(root.inputData.taskType, { bidChoice: bidChoice });
        root.Hide();
    }

    protected OnSliderValueChange(): void {
        // ui click sound
        AppAudioPlayer.PlaySfx(SoundEffectKeys.click4);
    }

    /**
     * cancel base functionality
     * - PopupWindow::screenOverlay will NOT be drawn
     */
    public override OnResize(windowRect: RectSize): void { }

    public UpdateViewFromLocalizationChange(languageId: LanguageId): void {
        // header ribbon
        this.txtHeader.text = AppLocalization.GetSharedData(languageId).table.bidding.popup.headerLabel;
        this.btnNoTrumps.label.text = AppLocalization.GetSharedData(languageId).general.noTrumpsShortText;
        this.btnAllTrumps.label.text = AppLocalization.GetSharedData(languageId).general.allTrumpsShortText;
        this.btnPass.label.text = AppLocalization.GetSharedData(languageId).table.declarations.pass;

        // NOTE: setting contra text might not be necessary here
        // It is set instantly on MAKE_BID and popup disappears as soon as bid is made.
        // @see SetContraType and TAbleMAchineCoinche/Contree: TaskStart: TaskTypeCoinche.MAKE_BID
        // const variationId: VariationId = AppLocalization.GetCurVariationId();
        // this.btnContra.label.text = AppLocalization.GetVariationData(variationId, languageId).table.bidPopup.contraBtn.choices[contraType];

        // stretch header bg to label width + padding
        this.nsHeaderBg.width = this.txtHeader.width + 2 * LayoutDataManager.GetSharedData().table.bidding.popup.header.padding.horizontal;
    }
}